import React from 'react';
import { createRoot } from 'react-dom/client';

import Root from './core/containers/Root';
import LocalStorageFallback from './core/components/LocalStorageFallback';
import { isLocalStorageAvailable } from './core/utils/storage';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'react-datepicker/dist/react-datepicker.css';
import './index.scss';

const runApp = () => {
    const rootElement = document.getElementById('root');
    const root = createRoot(rootElement);
    const canUseLocalStorage = isLocalStorageAvailable();
    root.render(canUseLocalStorage ? <Root /> : <LocalStorageFallback />);
};

runApp();
